
import React from "react";
import PageTop from "../../ui/page-top";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import FaqPane from "./faq-pane";
import useFetchFaq from "../../lib/hooks/use-fetch-faq";


export default function FaqDetail() {
  const user =  getCurrentUser();
  const { data:res,loading } = useFetchFaq();

  console.log("FaqDetail::",res);
  const page = res.status
    ? res.data
    : { title: " HiGorgeous FAQ", description: "Error fetching page" };

  return (
    <React.Fragment>
      <PageTop
        is_logged={user ? true : false}
        page={{ title: "Frequently Asked Questions", url: "/faq", bg_color: "sky" }}
      />
      {loading ? (<div className="page-body"><div className="pane-container py30">
            <div className="half-pane white px20 py20">
      Loading Page...
</div></div></div>
):(<>
      <div className="page-body">
          <div className="pane-container py30">
            <div className="half-pane white px20 py20">
           {res.status && <FaqPane data={page} />}
            </div>
          </div>
      </div></>)}
    </React.Fragment>
  );
}
